import { defineStore } from 'pinia'
import { ref } from 'vue'
import type { MessageShortcutDto } from '@/services/shortcut/interfaces'
import { useShortcutService } from '@/services/shortcut/useShortcutService'

export const useShortcutStore = defineStore('shortcuts', () => {
  const shortcuts = ref<MessageShortcutDto[]>([])
  const loading = ref(false)
  const currentCampaignId = ref<string | null>(null)

  const loadShortcuts = async (campaign_id: string, user_id?: string) => {
    if (!campaign_id || campaign_id === currentCampaignId.value) return
    loading.value = true
    try {
      const { getOperShortcuts } = useShortcutService()
      shortcuts.value = await getOperShortcuts(campaign_id, user_id)
      currentCampaignId.value = campaign_id
    } catch {
      // No se marca la campana como cargada: si no, la guarda de arriba daba el
      // fallo por bueno y el agente se quedaba sin atajos hasta cambiar de campana.
      shortcuts.value = []
      currentCampaignId.value = null
    } finally {
      loading.value = false
    }
  }

  const clearShortcuts = () => {
    shortcuts.value = []
    currentCampaignId.value = null
  }

  return { shortcuts, loading, loadShortcuts, clearShortcuts }
})
